import { Period } from '@/entities/Period/Period'
import { formatDate } from '@/helpers/date'
import { trans } from '@/helpers/trans'
import { DateFormat } from '@/types'

export const getAbsenceDateLabel = (period: Period): string => {
    const formattedStartDate = formatDate(period.start, DateFormat.dateWithStandAloneMonth)

    if (! period.hasEnd) {
        return `${trans('pages.absences.from')} ${formattedStartDate}`
    }

    const formattedEndDate = formatDate(period.end, DateFormat.dateWithStandAloneMonth)

    return `${formattedStartDate} ${trans('pages.absences.until')} ${formattedEndDate}`
}
